import { matchPath } from 'react-router-dom';

import { pageMap } from '@constants/permissions';

export const resolvePageMapPermission = (pathname: string, search = '') => {
  const exactKey = `${pathname}${search}`;
  if (pageMap[exactKey]) {
    return pageMap[exactKey];
  }

  const patternKey = Object.keys(pageMap)
    .filter((key) => key.includes(':'))
    .sort((left, right) => right.length - left.length)
    .find((key) => matchPath({ path: key, end: true }, pathname));

  return patternKey ? pageMap[patternKey] : undefined;
};

export default resolvePageMapPermission;
